import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@cimpress/react-components';

import '../../css/backgroundSelection.css';

const backgrounds = [
    '000000',
    'FFFFFF',
    '888888',
    '23FF99',
    '239923',
    '0000FF',
    'F03388',
    '00FFFF',
];

export default class BackgroundSelection extends Component {
    state = {
        background: this.props.background,
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.background !== this.state.background) {
            this.setState({ background: nextProps.background });
        }
    }

    updateBackground = (background) => {
        const trimmedBackground = background.trim();
        if (trimmedBackground.match(/^#(\d|[a-fA-F]){6}$/)) {
            this.props.onSelectBackground(trimmedBackground.slice(1));
        } else if (trimmedBackground.match(/^(\d|[a-fA-F]){6}$/) || !trimmedBackground) {
            this.props.onSelectBackground(trimmedBackground);
        } else {
            this.setState({ background: trimmedBackground });
        }
    }

    render() {
        const { onSelectBackground, color } = this.props;
        const { background } = this.state;
        return (
            <div className='color-attribute background-control' style={{ borderColor: color }}>
                <div className='background-control__title'>Background color</div>
                <li className='background-control__colors'>
                    <button className={`background-control__color background-control__color--none${background === '' ? ' active' : ''}`} onClick={() => onSelectBackground('')}>X</button>
                    {backgrounds.map(bg =>
                        (<button
                            key={bg}
                            className={`background-control__color${background === bg ? ' active' : ''}`}
                            onClick={() => onSelectBackground(bg)}
                            style={{ backgroundColor: `#${bg}` }}
                        />))
                    }
                    <TextField label='Hex Value' value={background} onChange={e => this.updateBackground(e.target.value)} />
                </li>
            </div>
        );
    }
}

BackgroundSelection.propTypes = {
    onSelectBackground: PropTypes.func.isRequired,
    background: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/rendering/backgroundSelection.jsx